import { render, staticRenderFns } from "./ManageResaleTaxModal.vue?vue&type=template&id=72c3c155"
import script from "./ManageResaleTaxModal.vue?vue&type=script&lang=js"
export * from "./ManageResaleTaxModal.vue?vue&type=script&lang=js"
import style0 from "./ManageResaleTaxModal.vue?vue&type=style&index=0&id=72c3c155&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports